import { render } from "./ResourceStatistics.vue?vue&type=template&id=5cb2771c&scoped=true&ts=true"
import script from "./ResourceStatistics.vue?vue&type=script&lang=ts"
export * from "./ResourceStatistics.vue?vue&type=script&lang=ts"

import "./ResourceStatistics.vue?vue&type=style&index=0&id=5cb2771c&scoped=true&lang=css"
import "./ResourceStatistics.vue?vue&type=style&index=1&id=5cb2771c&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb2771c"]])

export default __exports__